import { fieldPoolIpV4YupValidation } from '@/shared/utils/validationSchema';
import * as yup from 'yup';

export const oltFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
  //codigo: yup.string().required('El campo código es requerido'),
  // descripcion: yup.string().optional(),
  // user: yup.string().required('El campo usuario es requerido'),
  ip_pppoe: fieldPoolIpV4YupValidation.required('El campo ip pppoe es requerido'),
  password: yup.string().required('El campo password es requerido'),
  puerto: yup.string().required('El campo puerto es requerido'),
  comunidad_snmp: yup.string().required('El campo comunidad snmp es requerido'),
  version_snmp: yup.string().required('El campo version snmp es requerido'),
  estado_olt: yup.string().required('El campo estado olt es requerido'),
  coordenadas: yup.string().required('El campo coordenadas es requerido'),
  // sector: yup
  //   .string()
  //   .typeError('El campo sector es requerido')
  //   .required('El campo sector es requerido'),
  // zona: yup
  //   .string()
  //   .typeError('El campo zona es requerido')
  //   .required('El campo zona es requerido'),
  // provincia: yup.string().required('El campo provincia es requerido'),
  // ciudad: yup.string().required('El campo ciudad es requerido'),
  // nodo: yup.string().required('El campo nodo es requerido'),
});


export const generacionTroncalesSchema = yup.object({
  rango_inicio_manga: yup.string()
    .required('El campo rango inicio manga es requerido')
    .matches(
      /^[A-Z]{3}\s\d*1$/,
      "Formato inválido. Debe ser 'ABC 12171' (3 letras, espacio, número terminado en 1)"
    ),
  rango_fin_manga: yup.string()
    .required('El campo rango fin manga es requerido')
    .matches(
      /^[A-Z]{3}\s\d*1$/,
      "Formato inválido. Debe ser 'ABC 12171' (3 letras, espacio, número terminado en 1)"
    ),
});